import { combineReducers, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension';

import generalReducer from './general/reducer'

const rootReducers = combineReducers({
    GeneralStore: generalReducer,
})



 
const store = createStore(rootReducers, composeWithDevTools(
//   applyMiddleware(...middleware), => tuong lai se can
  // other store enhancers if any
));


export default store
